import { useState, useEffect, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import './App.css';
import NavBar from "./components/NavBar/NavBar";
import Hero from "./components/Hero/Hero";
import TrustBar from "./components/TrustBar/TurstBar";
import Cars from "./components/Cars/Cars";
import Footer from "./components/Footer/Footer";
import Context from "./storage/context";
import axios from "axios";
import Login from "./components/Login/Login";
import AdminPage from "./components/AdminPage/AdminPage"
import CarEditPage from "./components/CarEditPage/CarEditPage";
import NavAdmin from "./components/NavAdmin/NavAdmin";
import ReviewsBanner from "./components/ReviewsBanner/ReviewsBanner";
import BannerEditor from "./components/BannerEditor/BannerEditor";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import introVideo from "./images/roei_loading.mp4"
import ContactSection from "./components/ContactSection/ContactSection";
import AboutSection from "./components/AboutSection/AboutSection";
import UsersEditor from "./components/UsersEditor/UsersEditor";
import ReviewsPage from "./components/ReviewsPage/ReviewsPage";
import ReviewsEditor from "./components/ReviewsEditor/ReviewsEditor";
import PageWrapper from "./components/PageWrapper/PageWrapper";



function App() {
  let ctx = useContext(Context);
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();



  useEffect(() => {
    const fetchCars = async () => {
      try {
        const res = await axios.get(`${ctx.api_url}/cars`);
        ctx.setAllCars(res.data);
      } catch (error) {
        console.error("אופס, הלך המנוע (שגיאה בטעינת הרכבים):", error);
      }
    };

    fetchCars();
  }, []);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const res = await axios.get(`${ctx.api_url}/banner`);
        ctx.setBanner(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCars();
  }, []);




  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            {loading && (
              <LoadingScreen
                videoSrc={introVideo}
                onDone={() => {
                  setLoading(false);
                  navigate("/searchCar", { replace: true });
                }}
              />
            )}
          </>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <>
            <NavAdmin />
            {ctx.tagSelectedAdmin === "עריכת רכבים" ? <AdminPage /> : ctx.tagSelectedAdmin === "עריכת באנר המלצות" ? <BannerEditor /> : ctx.tagSelectedAdmin === "ניהול המלצות" ? <ReviewsEditor /> : <UsersEditor />}
          </>
        }
      />
      <Route path="/edit" element={<CarEditPage />} />
      <Route path="/new" element={<CarEditPage />} />
      <Route path="/searchCar" element={
        <PageWrapper title={"רועי קאר - חפש את הרכב הבא שלך"} page={"חיפוש רכבים"}>
          <NavBar />
          <Hero />
          <TrustBar />
          <Cars />
          <ReviewsBanner />
          <Footer />
        </PageWrapper>
      } />
      <Route path="/cars/:carId" element={
        <>
          <NavBar />
          <Hero />
          <TrustBar />
          <Cars />
          <ReviewsBanner />
          <Footer />
        </>
      } />
      <Route path="/contact" element={
        <PageWrapper title={"רועי קאר - צרו קשר"} page={"יצירת קשר"}>
          <NavBar />
          <ContactSection />
          <ReviewsBanner />
          <Footer />
        </PageWrapper>
      } />
      <Route path="/reviews" element={
        <PageWrapper title={"רועי קאר - לקוחות ממליצים"} page={"לקוחות ממליצים"}>
          <NavBar />
          <ReviewsPage />
          <ReviewsBanner />
          <Footer />
        </PageWrapper>
      } />
      <Route path="/about" element={
        <PageWrapper title={"רועי קאר - אודות החברה"} page={"אודות"}>
          <NavBar />
          <AboutSection />
          <ReviewsBanner />
          <Footer />
        </PageWrapper>
      } />

    </Routes>
  );
}

export default App;
